export default __webpack_public_path__ + "static/media/cs_icon_05_on.f1927aaf.png";